import React from 'react';
import Icon from 'react-icon-base';
import { any, number, oneOfType, string } from 'prop-types';

/* prettier-ignore */
const GeniallyIconWhiteIcon = ({
  className, color, height, size, style, width, ...restProps
}) => (
  /* eslint-disable */
  <Icon
    className={className}
    color={color}
    height={height}
    size={size}
    style={style}
    viewBox="0 0 16 16"
    width={width}
    {...restProps}
  >
    <g>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.99988 14.5479C9.74888 14.5479 11.3939 13.8659 12.6299 12.6299C13.8659 11.3939 14.5479 9.74889 14.5479 7.99989C14.5479 6.25089 13.8659 4.60689 12.6299 3.36989C11.3939 2.13289 9.74888 1.45289 7.99988 1.45289C6.25088 1.45289 4.60688 2.13289 3.36988 3.36989C2.13288 4.60689 1.45288 6.25089 1.45288 7.99989C1.45288 9.74889 2.13288 11.3939 3.36988 12.6299C4.60688 13.8659 6.25088 14.5479 7.99988 14.5479ZM2.34288 2.34289C5.46688 -0.781107 10.5319 -0.781107 13.6569 2.34289C16.7809 5.46689 16.7809 10.5319 13.6569 13.6569C10.5319 16.7809 5.46688 16.7809 2.34288 13.6569C-0.781122 10.5319 -0.781122 5.46689 2.34288 2.34289ZM11.9814 8.00005C11.6144 8.00005 11.2964 8.25805 11.2244 8.61805C10.9374 10.057 9.66837 11.141 8.14437 11.141C6.34437 11.141 4.89837 9.62605 5.01037 7.80105C5.10837 6.19405 6.44637 4.90505 8.05537 4.86005C8.45037 4.85005 8.82837 4.91205 9.17837 5.03405C9.51837 5.15305 9.89537 5.02705 10.0784 4.71705L10.1114 4.66105C10.3494 4.25705 10.1554 3.74105 9.71337 3.58405C9.17337 3.39205 8.58837 3.29505 7.97737 3.31705C5.54037 3.40205 3.55137 5.38705 3.46137 7.82405C3.36337 10.4921 5.49837 12.687 8.14437 12.687C10.4194 12.687 12.3174 11.063 12.7424 8.91305C12.8354 8.43905 12.4634 8.00005 11.9814 8.00005ZM9.27829 7.53273C8.72129 7.53273 8.26929 7.98473 8.26929 8.54073C8.26929 9.09773 8.72129 9.54873 9.27829 9.54873C9.83529 9.54873 10.2863 9.09773 10.2863 8.54073C10.2863 7.98473 9.83529 7.53273 9.27829 7.53273Z"/>
    </g>
  </Icon>
  /* eslint-enable */
);

GeniallyIconWhiteIcon.propTypes = {
  className: string,
  color: string,
  height: oneOfType([string, number]),
  size: oneOfType([string, number]),
  style: any, // eslint-disable-line react/forbid-prop-types
  width: oneOfType([string, number]),
};

export default GeniallyIconWhiteIcon;
